import { useTranslation } from 'react-i18next';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { setStorageItem } from '@/common/integrations/storage/storage.service';

export const CardDetailsBanner = () => {
  const { t } = useTranslation();

  return (
    <CardActionLink
      icon={<Icon icon="credit-card" color="neutral10" />}
      iconBadgeColor="accentSecondary40"
      title={t('wallet.card.card_details.title')}
      href={ROUTES.CARD}
      withAnchor
      onPress={async () => {
        await setStorageItem(
          'cvrflex_flightdeck_check_digital_card_details_dismissed',
          true
        );
      }}
      size="md"
    />
  );
};
